// import { ContentDataType } from "../types-v6"

import { ContentDataType, FieldDefinition } from '../types-v6'
import { ContentEditorActions } from './ContentEditorActions'
import { ItemHeaderLayout } from './ItemHeaderLayout'

export function Statement({
  item,
  headerFields,
  contentFields,
  canEditContent,
  canDeleteContent,
  field,
  parentId,
}: {
  item: ContentDataType
  headerFields?: FieldDefinition[]
  contentFields?: FieldDefinition[]
  canEditContent: boolean
  canDeleteContent: boolean
  field: FieldDefinition
  parentId: string
}) {
  return (
    <div className="flex w-full flex-col gap-y-5 rounded-lg bg-background shadow">
      <div className="bg-offwhite/50 flex justify-end gap-x-2 border-b">
        {headerFields && <ItemHeaderLayout headerFields={headerFields} content={item} />}
        <ContentEditorActions
          content={item}
          canEditContent={canEditContent}
          canDeleteContent={canDeleteContent}
          uiSchema={field}
          handlerId={field.handlerId}
          parentId={parentId}
          // contentFormSchema={injectFormDefaults(contentFormSchema, content)}
        />
      </div>
      <div className="flex flex-col gap-y-2 px-5 pb-5">
        {contentFields?.map((field) => {
          const fieldValue = item[field.propertyId]
          if (typeof fieldValue === 'string') {
            return (
              <div key={field.propertyId}>
                <div className="whitespace-pre-wrap">{fieldValue}</div>
              </div>
            )
          }
          return null
        })}
      </div>
    </div>
  )
}
